import { Home, Users, Network, Landmark, Contact, BookOpen, FileText, FolderKanban,
  Receipt, ShieldAlert, Server, Newspaper, ClipboardList, ShieldCheck, CalendarDays, Images, Clock, ListChecks, LifeBuoy } from "lucide-react";

export const NAV_GROUPS = [
  {
    label: "Firm Hub",
    items: [
      { to: "/", label: "Home", icon: Home, testid: "nav-home" },
      { to: "/news", label: "Firm News", icon: Newspaper, testid: "nav-news" },
      { to: "/calendar", label: "Calendar", icon: CalendarDays, testid: "nav-calendar" },
      { to: "/gallery", label: "Photo Gallery", icon: Images, testid: "nav-gallery" },
    ],
  },
  {
    label: "People",
    items: [
      { to: "/people", label: "Staff Directory", icon: Users, testid: "nav-people" },
      { to: "/org-chart", label: "Org Chart", icon: Network, testid: "nav-orgchart" },
    ],
  },
  {
    label: "Practice",
    items: [
      { to: "/practice-groups", label: "Practice Groups", icon: BookOpen, testid: "nav-practice" },
      { to: "/brief-bank", label: "Brief Bank", icon: FileText, testid: "nav-briefbank" },
      { to: "/courts", label: "Court Center", icon: Landmark, testid: "nav-courts" },
      { to: "/vendors", label: "Vendors & Experts", icon: Contact, testid: "nav-vendors" },
    ],
  },
  {
    label: "Operations",
    items: [
      { to: "/matter", label: "Matter Lifecycle", icon: FolderKanban, testid: "nav-matter" },
      { to: "/my-tasks", label: "My Tasks", icon: ListChecks, testid: "nav-mytasks" },
      { to: "/tickets", label: "Monge Ticketing", icon: LifeBuoy, testid: "nav-tickets" },
      { to: "/time", label: "Time Clock", icon: Clock, testid: "nav-time" },
      { to: "/billing", label: "Billing & Trust", icon: Receipt, testid: "nav-billing" },
      { to: "/ethics", label: "Ethics & Risk", icon: ShieldAlert, testid: "nav-ethics" },
      { to: "/it", label: "IT & Security", icon: Server, testid: "nav-it" },
      { to: "/forms", label: "Brand & Forms", icon: ClipboardList, testid: "nav-forms" },
    ],
  },
];

export const ADMIN_ITEM = { to: "/admin", label: "Administration", icon: ShieldCheck, testid: "nav-admin" };
